import React, { useState } from 'react'
import { Button, Chip, Grid, Typography } from '@material-ui/core'
import { Search as SearchIcon } from '@material-ui/icons'
import { styles } from '../styles/js/headerActions'
import { withStyles } from '@material-ui/core/styles'

const HeaderActionsComponent = ({
  classes,
  setDialogSearch,
  setDialogShare,
  searchParams,
  clearSearch,
}) => {
  const [scrollAbove, setScrollAbove] = useState(false)

  window.addEventListener('scroll', function(event) {
    if (this.scrollY >= 450 && !scrollAbove) {
      setScrollAbove(true)
    }

    if (this.scrollY < 450 && scrollAbove) {
      setScrollAbove(false)
    }
  })

  const renderSearchText = () => {
    const { data_inicio, data_fim, telespectador } = searchParams

    let dateMessage = ''

    if (data_inicio && data_fim) {
      if (data_inicio.toString() === data_fim.toString()) {
        dateMessage = `no dia ${data_inicio.format('DD/MM/YYYY')}`
      } else {
        dateMessage = `do dia ${data_inicio.format(
          'DD/MM/YYYY'
        )} ao dia ${data_fim.format('DD/MM/YYYY')}`
      }
    }

    if (data_inicio && !data_fim) {
      dateMessage = `a partir do dia ${data_inicio.format('DD/MM/YYYY')}`
    }

    if (!data_inicio && data_fim) {
      dateMessage = `até o dia ${data_fim.format('DD/MM/YYYY')}`
    }

    return (
      <>
        {telespectador && (
          <Typography variant='h5' className={classes.telespectadorSection}>
            Buscando por{' '}
            <span className={classes.telespectadorName}>{telespectador}</span>
          </Typography>
        )}

        {(data_inicio || data_fim) && (
          <Typography
            variant={`${telespectador ? 'h5' : 'h5'}`}
            className={classes.dateSection}
          >
            {!telespectador ? 'Buscando ' : ''}{' '}
            <span className={classes.dateSectionName}>{dateMessage}</span>
          </Typography>
        )}
      </>
    )
  }

  return (
    <Grid
      container
      justifyContent='center'
      alignItems='center'
      className={
        classes.root + (scrollAbove ? ' ' + classes.greyBackground : '')
      }
    >
      <Grid item xs={12}>
        <Grid container justifyContent='center'>
          <Button
            variant='contained'
            color='primary'
            size='large'
            className={classes.searchButton}
            startIcon={<SearchIcon />}
            onClick={() => setDialogSearch({ isOpen: true, data: null })}
          >
            Procure sua foto
          </Button>
        </Grid>
      </Grid>

      {(searchParams.telespectador ||
        searchParams.data_inicio ||
        searchParams.data_fim) && (
        <Grid item xs={12} className={classes.searchParamsSection}>
          <Grid container justifyContent='center'>
            <Chip
              label={renderSearchText()}
              onDelete={clearSearch}
              color='primary'
              className={classes.chip}
              classes={{
                label: classes.chipLabel,
              }}
            />
          </Grid>
        </Grid>
      )}
    </Grid>
  )
}

export default withStyles(styles)(HeaderActionsComponent)
